import { render, staticRenderFns } from "./SwiftSport.vue?vue&type=template&id=075e328e&"
import script from "./SwiftSport.vue?vue&type=script&lang=ts&"
export * from "./SwiftSport.vue?vue&type=script&lang=ts&"
import style0 from "./SwiftSport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports